import React, { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const UserContext = createContext();

// Custom hook to access UserContext easily
export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserDetails = async () => {
      const token = Cookies.get("prgiToken"); // Or fetch from cookies
      if (!token) {
        setUser(null);
        setLoading(false);
        return;
      }
      //   console.log(token);
      try {
        const response = await fetch(
          "https://ajayreddy9-prgi.hf.space/auth/user/me",
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          console.log(data);
          setUser(data); // Set user details from token
        } else {
          Cookies.remove("prgiToken");
          setUser(null); // Clear user if token is invalid
          navigate("/signin");
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        setUser(null);
      }
      setLoading(false);
    };

    fetchUserDetails();
  }, [navigate]);

  return (
    <UserContext.Provider value={{ user, setUser, loading }}>
      {children}
    </UserContext.Provider>
  );
};
